module.exports = __webpack_public_path__ + "img/TiU_Logo.714c4a4b.png";